import http from '@/utils/http'
export default {
  getCpUserInfo: (params) => {
    return http.post('/json/web/queryCpUserInfo', params)
  },
  getProductList: (params) => {
    return http.post('/json/web/productList', params)
  },
  getPayMethodList: (params) => {
    return http.post('/json/web/payWayList', params)
  },
  createWebOrder: (params) => {
    return http.post('/json/web/createWebOrder', params)
  },
  queryWebOrderById: (params) => {
    return http.post('/json/web/queryWebOrderById', params)
  }
}


